import React from "react";
import {useAppStore} from "../../../common/app.store.consumer";
import {ReportChartComponent} from "../types/report.chart.component";
import Chart, {Size} from "devextreme-react/chart";
import {Series, Legend, ValueAxis, Label, Tooltip, Font, Tick, Grid, ArgumentAxis, CommonSeriesSettings} from "devextreme-react/chart";

type Props = ReportChartComponent;

const ReportChartBar: React.FC<Props> = useAppStore()((props: Props) => {
	const store = props.appStore.reportPageStore;

	function customizeTooltip(pointInfo) {		
		//Show tooltip only for score
		if(pointInfo.seriesName === "Series 1"){
			return {
				text: `${(Math.round(pointInfo.value*100))} %`
			};
		}						
		return {text:null};
	}

	return (
		<Chart
			dataSource={store.taxonomyOrderedAnswerSheetDetails.map((data) => ({
				taxonomyName: data.taxonomyName,
				score: data.score,
				amountToMax: 1-data.score,
			}))}
			rotated={true}
			id="ReportChartBar"
		>
			<Size width={"100%"} height={260} />
			<CommonSeriesSettings argumentField="taxonomyName" barWidth={8} type="fullstackedbar" />
			<Series valueField="score" color="#42BEA9" />
			<Series valueField="amountToMax" color="#F0F0F0" />
			<Legend visible={false} />
			<ArgumentAxis visible={false} inverted={true}>
				<Tick visible={false} />
				<Label indentFromAxis={25}>
					<Font size={16} family="Roboto" />
				</Label>
			</ArgumentAxis>
			<ValueAxis tickInterval={0.2 as any} visible={false}>
				<Tick visible={false} />
				<Label visible={false} />
				<Grid visible={true} color="#F2F2F2" />
			</ValueAxis>
			<Tooltip enabled={true} customizeTooltip={customizeTooltip}>
				<Font size={16} weight="bold" color="#333333" />
			</Tooltip>
		</Chart>
	);
});

export default ReportChartBar;
